import PropTypes from "prop-types";
import formatDate from "./../libs/formatDate";

export const renderGridDateColumn = (rowData, col) => {

    const { format } = col.colSettings || { format: 'MM/DD/YYYY' }; // Provide a default format if colSettings is not defined
    const dateValue = rowData?.[col.fieldName]

    return (
        formatDate(dateValue, format)
    );
};

renderGridDateColumn.propTypes = {
    rowData: PropTypes.object.isRequired,
    col: PropTypes.shape({
        colSettings: PropTypes.shape({
            format: PropTypes.string
        }),
        fieldName: PropTypes.string.isRequired
    }).isRequired
};